import { buildEndPoint } from '@mairistem/tools';

import { formatFilters, formatSort } from '@/utils';
import baseUrl from './base';

export const getArretes = (
  {
    page,
    perPage,
    sorts,
    filters,
    ...rest
  }: {
    page?: number;
    perPage?: number;
    sorts?: any[];
    filters?: any[];
    [key: string]: any;
  } = {
    page: 1,
    perPage: 50,
    sorts: [],
    filters: [],
  },
) =>
  buildEndPoint(`${baseUrl}/arretes`, {
    page,
    perPage: perPage || 50,
    sort: formatSort(sorts),
    ...formatFilters(filters),
    ...rest,
  });

export const searchArretes = (
  {
    page,
    query,
    perPage,
    sorts,
    filters,
    ...rest
  }: {
    page?: number;
    query?: string;
    perPage?: number;
    sorts?: any[];
    filters?: any[];
    [key: string]: any;
  } = {
    page: 1,
    query: '',
    perPage: 50,
    sorts: [],
    filters: [],
  },
) =>
  buildEndPoint(`${baseUrl}/arretes/search`, {
    page,
    perPage: perPage || 50,
    q: query,
    sort: formatSort(sorts),
    ...formatFilters(filters),
    ...rest,
  });

export const postArrete = () => `${baseUrl}/arretes`;

export const putArrete = (identifiant: number) => `${baseUrl}/arretes/${identifiant}`;

export const postArreteAutomatique = () => `${baseUrl}/arretes/automatique`;

export const postArreteEditionsPeriodique = () => `${baseUrl}/arretes/editions-periodique`;

export const getArretePrevisionnelPeriodique = (arreteAnnuel = false, dateFin?: string) =>
  buildEndPoint(`${baseUrl}/arretes/previsionnel-periodique`, {
    arreteAnnuel: arreteAnnuel ? 1 : undefined,
    dateFin,
  });

export const getArretePointagesReglement = () => `${baseUrl}/arretes/pointages-reglement`;
export const postArretePointagesReglement = () => `${baseUrl}/arretes/pointages-reglement`;
// Les identifiants passent en query string car request.delete de @mairistem/tools n'accepte
// pas de body (options: timeout/headers/responseType/rewrite/signal uniquement). Laravel lit
// indifféremment body et query via $request->input().
export const deleteArretePointagesReglement = (identifiantReglements: number[]) =>
  buildEndPoint(`${baseUrl}/arretes/pointages-reglement`, {
    'identifiantReglements[]': identifiantReglements,
  });
